import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shippingField", "onlineBookDueDateField", "printNotification"]
  shippingFieldTarget: HTMLElement
  onlineBookDueDateFieldTarget: HTMLElement
  printNotificationTarget: HTMLElement

  connect() {}

  toggle() {
    const printedCopyCheckbox = this.element as HTMLInputElement
    const shippingField = this.shippingFieldTarget as HTMLElement
    const printNotification = this.printNotificationTarget as HTMLElement

    shippingField.classList.toggle("hidden", printedCopyCheckbox.checked)
    printNotification.classList.toggle("hidden", printedCopyCheckbox.checked)
  }
  toggleOnlineBookDueDate() {
    const DueDateSectioon = this.onlineBookDueDateFieldTarget as HTMLElement
    DueDateSectioon.classList.toggle("hidden")
  }
}
